import request from './request'
import {getCookie} from "@/helpers";
import {api} from "@/api/requestGraphql";

let getAccountManagers = async (data) => {
  try {
    console.time(`getAccountManagers`)
    const result = await request.get(`${process.env.VUE_APP_BACKOFFICE_MANAGERS_URL}/getAccountManagers`, {
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': 'https://backoffice.jatun.systems/'
      }
    })

    let accountManagers = {}

    result.data.forEach(row => {
      accountManagers[row.id] = row.name
    })

    console.timeEnd(`getAccountManagers`)
    return accountManagers
  } catch (err) {
    console.log(err)
  }
}

let getAccountExecutives = async (data) => {
  try {
    console.time(`getAccountExecutives`)
    const result = await request.get(`${process.env.VUE_APP_BACKOFFICE_MANAGERS_URL}/getAccountExecutives`, {
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': 'https://backoffice.jatun.systems/'
      }
    })

    let accountExecutives = {}

    result.data.forEach(row => {
      accountExecutives[row.id] = row.name
    })

    console.timeEnd(`getAccountExecutives`)
    return accountExecutives
  } catch (err) {
    console.log(err)
  }
}

let getAccountNotifications = async (data) => {
  try {
    const result = await request.get(`${process.env.VUE_APP_BACKOFFICE_MANAGERS_URL}/getAccountNotifications`, {
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': 'https://backoffice.jatun.systems/'
      }
    })

    return result.data
  } catch (err) {
    console.log(err)
  }
}

let saveReadNotifications = async (data) => {
  try {
    let queryData = new URLSearchParams()
    queryData.append('notifications', JSON.stringify(data.notifications))

    return await request.post(`${process.env.VUE_APP_BACKOFFICE_MANAGERS_URL}/saveReadNotifications`, queryData, {
      headers: {
        'Authorization': data.token,
        'Content-Type': 'application/x-www-form-urlencoded',
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': 'https://backoffice.jatun.systems/'
      }
    })

  } catch (err) {
    console.log(err)
  }
}

const getAffiliateManagers = async (data) => {
  try {
    const result = await request.post(`/graphql`, {
          query: `{
        affiliateManagers {
          id,
          name
          email
        }
      }`
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': localStorage.getItem('workspace') || 'ac'
          }
        }
    )

    if (result.status === 200 && result.data && result.data.data && result.data.data.affiliateManagers) {
        return result.data.data.affiliateManagers;
    } else {
      throw new Error('Error while requesting list of managers');
    }
  } catch (error) {
    throw error;
  }
}

const getSignupLink = async (data) => {
  const result = await request.post(`/graphql`, {
        query: `{
            getSignupLink(employeeId:${data.employeeId})
          }`
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
  )
  if (result.data.errors) {
    throw new Error(result.data.errors[0].message);
  }
  if (result.status === 200 && result.data && result.data.data && result.data.data.getSignupLink) {
    return result.data.data.getSignupLink;
  } else {
    throw new Error('Error while requesting Signup Link');
  }
}

let getMassAssignManagerList = async () => {
  return api.post(
    '', {
      query: `
        {
          massAssignManagerList {
            id
            name
          }
        }`,
    });
}

const getAffiliateByManager = async (managerId) => {
  try {
    const result = await request.post(`/graphql`, {
        query: `{
        affiliatesByManager(managerId:${managerId}) {
          id,
          name
          email
        }
      }`
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
    )

    if (result.status === 200 && result.data && result.data.data && result.data.data.affiliatesByManager) {
      return result.data.data.affiliatesByManager;
    } else {
      throw new Error('Error while requesting list of managers');
    }
  } catch (error) {
    throw error;
  }
}

const getAccountManager = async (pagination, sorting, filters, isShowInactive) => {
  try {
    const res = await api.post(
        '', {
          query: `
                {
                    accountManagers(
                        pagination: { page: ${pagination.page}, limit: ${pagination.limit} }, 
                        sorting: { orderBy: "${sorting.orderBy}", orderDirectionAsc: ${sorting.orderDirectionAsc} }
                        filters: { ${prepareFilters(filters)} }
                        isShowInactive: ${isShowInactive||false}
                    ) {
                        count
                        data {
                            id
                            name
                            email
                            platformEmployeeId
                            role
                            status
                            user
                            skypeId
                            dateAdded
                            dateUpdated
                        }
                    }
                }
                `,
        }
    );

    let response = res.data.data.accountManagers;
    // console.log(`response ${JSON.stringify(response)}`);
    return response;
  } catch (e) {
    console.log(e);
  }
};

const prepareFilters = (filters) => {
  let preparedFilters = '';

  for (const filter in filters) {
    preparedFilters += (!!filters[filter]) ?
        `${filter}: "${filters[filter]}", ` : '';
  }

  return preparedFilters;
};

const getUmbrellaUsers = async () => {
    try {
        const res = await api.post(
            '', {
            query: `
                    {
                        umbrellaUsers {
                            email
                            picture
                            name
                            role
                            employee_id
                            is_admin
                            status
                            sfl_manager_id
                        }
                    }
                    `,
            }
        );

        let response = res.data.data.umbrellaUsers;
        // console.log(`response ${JSON.stringify(response)}`);
        return response;
    } catch (e) {
        console.log(e);
    }

}

const createOrUpdateAccountManager = async (data) => {
    try {
        const res = await api.post(
            '', {
            query: `
                    mutation {
                        createOrUpdateAccountManager(
                            id: ${data.id},
                            name: "${data.name}",
                            email: "${data.email}",
                            platformEmployeeId: ${data.platformEmployeeId},
                            role: "${data.role}",
                            status: "${data.status}",
                            user: "${data.user}",
                            skypeId: "${data.skypeId}"
                        ) {
                            id
                            error
                        }
                    }
                    `,
            }
        );

        let response = res.data.data.createOrUpdateAccountManager;
        console.log(`response ${JSON.stringify(response)}`);
        return response;
    } catch (e) {
        console.log(e);
    }

}

const getAccountManagerFilterData = async () => {
    try {
        const res = await api.post(
            '', {
            query: `
                {
                  getAccountManagerFilterData {
                    filters {
                      id {
                        key
                        value
                      }
                      email {
                        key
                        value
                      }
                      name {
                        key
                        value
                      }
                      skypeId {
                        key
                        value
                      }
                      role {
                        key
                        value
                      }         
                      status {
                        key
                        value
                      }                                       
                    }
                  }
                }
            `,
            }
        );

        let response = res.data.data.getAccountManagerFilterData;
        // console.log(`response ${JSON.stringify(response)}`);
        return response;
    } catch (e) {
        console.log(e);
    }


}

const getAccountManagersHistoryById = async (id) => {
    try {
        const res = await api.post(
            '', {
            query: `
                {
                  getAccountManagersHistoryById(id: ${id}) {
                    entity
                    user
                    action
                    logs
                    dateAdded
                  }
                }
            `,
            }
        );

        let response = res.data.data.getAccountManagersHistoryById;
        console.log(`response ${JSON.stringify(response)}`);
        return response;
    } catch (e) {
        console.log(e);
    }
}
const deleteManager = async (id) => {
    try {
        const res = await api.post('', {
            query: `
                mutation {
                  deleteManager(id: ${id})
                }
      `,
        });

        let response = res.data.data.deleteManager;
        console.log(`deleteManager mutation response : `, response);
        return response;
    } catch (e) {
        console.error(e);
    }

}
export default {
  getAccountManagers,
  getAccountExecutives,
  getAccountNotifications,
  saveReadNotifications,
  getAffiliateManagers,
  getMassAssignManagerList,
  getSignupLink,
  getAffiliateByManager,
  getAccountManager,
  getUmbrellaUsers,
  createOrUpdateAccountManager,
  getAccountManagerFilterData,
  getAccountManagersHistoryById,
  deleteManager
}
